export const createScript = (id: string) => {
  if (!document.getElementById('klarna-script-tag')) {
    const script = document.createElement('script');
    script.setAttribute('src', 'https://x.klarnacdn.net/kp/lib/v1/api.js');
    script.setAttribute('async', 'true');
    script.setAttribute('id', id);

    document.body.appendChild(script);
  }
};
